/** Deterministic mulberry32 PRNG for terrain and preview jitter. */
export function mulberry32(seed: number): () => number {
	let t = seed >>> 0;
	return () => {
		t += 0x6d2b79f5;
		let r = Math.imul(t ^ (t >>> 15), t | 1);
		r ^= r + Math.imul(r ^ (r >>> 7), r | 61);
		return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
	};
}

export function hashSeed(parts: number[]): number {
	let h = 2166136261;
	for (const p of parts) {
		h ^= p | 0;
		h = Math.imul(h, 16777619);
	}
	return h >>> 0;
}
